export const getDiscussionId = `
  discussion {
    id
  }
`;

const getRepliesId = `
  replies {
    id
    text
    userId
    createdAt
    attachments
  }
`;

export const getChannelId = `
  channel {
    id
  }
`;

export const commentInfo = `
  id
  text
  userId
  createdAt
  score
  attachments

  ${getRepliesId}
`;

export const discussionInfo = `
  id
  name
  text
  createdAt
  userId
  attachments
`;

export const channelInfo = `
  id
  name
`;
